export default __webpack_public_path__ + "static/media/gallery4.0fe8482e.jpg";